<div class="outerAccord">
  <div ngbAccordion
    #dateDrilldownAccordion="ngbAccordion"
    activeIds="headerpanel">

    <div ngbAccordionItem [id]="'headerpanel'" [collapsed]="false">
      <div class="accordion-header">
        <button type="button" class="accordion-button" aria-expanded="true" aria-controls="headerpanel">
          <div class="accordion-label custom-header">
            <button
              type="button"
              ignore-readonly
              (click)="toggleDateDrilldownPicker()"
              class="icon-btn">
              <i class="far fa-times"></i>
            </button>
            <div class="accordion-label-separator"></div>
            <button
              type="button"
              ignore-readonly
              class="accordion-label-item accordion-label-txt"
              (click)="period.selected()"
              [ngClass]="{'active-parent': period.active}">
              {{ period.label }}
            </button>
          </div>
        </button>
      </div>

      <div ngbAccordionCollapse>
        <div class="inner-accordion">
          @for (month of months; track month; let i = $index) {
            <div ngbAccordionItem [id]="'month_' + i"
              [collapsed]="false">
              <div class="accordion-header">
                <div class="accordion-label">
                  <button
                    type="button"
                    ignore-readonly
                    class="btn btn-icon icon-btn accordion-trigger"
                    (click)="month.toggleExpanded()">
                    <i class="far fa-chevron-down rotate" [ngClass]="{'down' :  month.expanded}"></i>
                  </button>
                  <div class="accordion-label-separator"></div>
                  <button
                    type="button"
                    id="btnMonth_{{i}}"
                    ignore-readonly
                    class="accordion-label-item accordion-label-txt"
                    (click)="stopPropagation($event); month.selected()"
                    [ngClass]="{'active-parent': month.active}">
                    {{ month.label }}
                  </button>
                </div>
              </div>
              <div ngbAccordionCollapse>
                @if (month.expanded) {
                  <div>
                    <ul>
                      @for (week of month.weeks; track week) {
                        <li>
                          <div class="accordion-label">
                            <button
                              type="button"
                              ignore-readonly
                              class="weekBtn accordion-label-txt"
                              (click)="week.selected()"
                              [ngClass]="{'active-parent': week.active}">
                              Vecka {{ week.label }}
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>